export default {
  currentPage: state => state.currentPage,
  currentMode: state => state.currentMode,
  currentActiveMenu: state => state.currentActiveMenu,
  getMenu: state => state.menu,
  getMenuSuspended: state => state.menuSuspended
};
